<template>
  <div class="ai-chat-skill-suggestions">
    <button
      v-for="skill in suggestions"
      :key="skill.id"
      type="button"
      class="_suggestion"
      @click="$emit('use', skill)"
    >
      <m-icon
        class="_icon"
        :type="skill.icon"
      />
      <span class="_title">{{ skill.title }}</span>
    </button>
  </div>
</template>

<script setup>
import useAiChatSkills from '@/composables/ai-chat/ai-chat-skills';

defineEmits(['use']);

const { suggestions } = useAiChatSkills();
</script>

<style
  scoped
  lang="scss"
  type="text/scss"
>
  .ai-chat-skill-suggestions {
    display: flex;
    flex-direction: column;
    gap: .2rem;

    ._suggestion {
      display: flex;
      align-items: center;
      gap: 1.2rem;
      width: 100%;
      padding: .8rem;
      text-align: left;
      color: $font-color-primary;
      background: none;
      border: none;
      border-radius: $default-border-radius;
      cursor: pointer;

      &:hover {
        background-color: map_get($grey, 'lighten-6');
      }
    }

    ._icon {
      flex-shrink: 0;
      color: $font-color-secondary;
    }

    ._title {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>
